import {
  Shield,
  Clock,
  Users,
  Award,
  Star,
  Plane,
  MapPin,
  Car,
  Heart,
  Zap,
  Compass,
  Building2,
  DollarSign,
  Headphones,
  Map,
  Phone,
  Mail,
  MessageCircle,
  CheckCircle,
  Globe,
  Camera,
  Palmtree,
  Sun,
  Waves,
  Mountain,
  type LucideIcon
} from "lucide-react";

const iconMap: Record<string, LucideIcon> = {
  Shield,
  Clock,
  Users,
  Award,
  Star,
  Plane,
  MapPin,
  Car,
  Heart,
  Zap,
  Compass,
  Building2,
  DollarSign,
  Headphones,
  Map,
  Phone,
  Mail,
  MessageCircle,
  CheckCircle,
  Globe,
  Camera,
  Palmtree,
  Sun,
  Waves,
  Mountain,
};

export const getIcon = (iconName: string): LucideIcon => {
  return iconMap[iconName] || Shield;
};

export const getIconComponent = (iconName: string) => {
  const IconComponent = iconMap[iconName] || Shield;
  return IconComponent;
};

export default iconMap;
